import { useCallback, useContext, useState } from "react";
import { CheckoutSessionFragment } from "v3/services/graphql/generated";
import { CheckoutErrorContext } from "../checkoutError";
import { CHECKOUT_STEPS } from "v3/types/checkout";
import { scrollTo } from "@pepdirect/v3/helpers/scroll";

export interface CheckoutContextInterface {
  apiBaseUrl: string;
  checkoutSession: CheckoutSessionFragment | null;
  isLoading: boolean;
  scrollToCouponInput: boolean;
  setCheckoutSession: (val: CheckoutSessionFragment) => void;
  setIsLoading: (isLoading: boolean) => void;
  setScrollToCouponInput: (scroll: boolean) => void;
  setStep: (val: CHECKOUT_STEPS) => void;
  setCartId: (val: string) => void;
  step: CHECKOUT_STEPS;
  cartId: string;
  transitionToStep: (
    step: CHECKOUT_STEPS,
    shouldNotClearErrors?: boolean
  ) => void;
}

export function useCheckoutProvider(apiBaseUrl: string): {
  checkoutContextValue: CheckoutContextInterface;
} {
  const { clearAllErrors } = useContext(CheckoutErrorContext);

  const [isLoading, setIsLoading] = useState(false);
  const [cartId, setCartId] = useState("");
  const [checkoutSession, setCheckoutSession] =
    useState<CheckoutSessionFragment | null>(null);
  const [step, setStep] = useState<CHECKOUT_STEPS>(CHECKOUT_STEPS.shipping);
  const [scrollToCouponInput, setScrollToCouponInput] = useState(false);

  const transitionToStep = useCallback(
    (nextStep: CHECKOUT_STEPS, shouldNotClearErrors?: boolean) => {
      setStep(nextStep);
      !shouldNotClearErrors && clearAllErrors();
      scrollTo();
    },
    [clearAllErrors]
  );

  const checkoutContextValue: CheckoutContextInterface = {
    apiBaseUrl,
    checkoutSession,
    isLoading,
    scrollToCouponInput,
    setCheckoutSession,
    setIsLoading,
    setScrollToCouponInput,
    setStep,
    step,
    cartId,
    transitionToStep,
    setCartId,
  };

  return { checkoutContextValue };
}
